import { SheqManagerListTable } from "./components/SheqManagerListTable";

export default SheqManagerListTable;